import { setImportPending, setImportError, setImportFinish, setExportFinish, setExportError, setExportPending } from "./actions";
import { getErrorMessage } from "../helpers/errorParser";
import { Observable } from "rxjs";
import { actionTypes } from "./actionTypes";
const REG_CONTENT_DISP = /filename=\"(.*\.zip)\"/;
function getFileName(contentDisposition) {
    return REG_CONTENT_DISP.exec(contentDisposition)[1] || "test.zip";
}
const saveFile = saveAs => (filename, response) => {
    const receivedFileName = getFileName(filename);
    saveAs(response.response, receivedFileName);
};
export const importEpic = importUrl => (action$, _, { ajax }) => {
    return action$.ofType(actionTypes.IMPORT).mergeMap(action => {
        const fd = new FormData();
        fd.append("file", action.payload.file);
        return ajax({
            url: importUrl(action.payload),
            method: "POST",
            body: fd
        })
            .map(() => setImportFinish(action.payload))
            .catch((error) => Observable.of(setImportError(action.payload, getErrorMessage(error))))
            .startWith(setImportPending(action.payload));
    });
};
export const exportEpic = (exportUrl, saveAs) => (action$, _, { ajax }) => {
    return action$.ofType(actionTypes.EXPORT).mergeMap(action => {
        return ajax({
            url: exportUrl(action.payload),
            headers: { "content-type": "application/zip" },
            responseType: "blob"
        })
            .do(res => saveFile(saveAs)(res.xhr.getResponseHeader("content-disposition"), res))
            .map(() => setExportFinish(action.payload))
            .catch((error) => Observable.of(setExportError(action.payload, getErrorMessage(error))))
            .startWith(setExportPending(action.payload));
    });
};
//# sourceMappingURL=middleware.js.map